export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9075.713e0c10.jpg";